'use client';
import React from 'react';

import { Layout } from '@whelk/components';
import PageLoading from '@whelk/components/src/PageLoading';
import { RootState } from '@whelk/store';
import { useSelector } from 'react-redux';

const HistoryLayout = ({ children }: { children: React.ReactElement }) => {
  const initUserLoading = useSelector((state: RootState) => state.user.initUserLoading);
  if (initUserLoading) {
    return <PageLoading />;
  }

  return <Layout>{children}</Layout>;
};

export default HistoryLayout;
